
/**
 * Delays the next execution of the same function to after the previous execution ended (all calls in between will be discarded)
 * @param {Function} asyncFn
 * @returns {Function} a new function
 */
export function debounceUntilResolved(asyncFn) {
    let runningPromise = null;
    let dirty = false;

    const run = async () => {

        if (runningPromise) {
            dirty = true;
            return runningPromise;
        }

        runningPromise = (async () => {
            try {
                await asyncFn();
            } finally {
                runningPromise = null;

                if (dirty) {
                    dirty = false;
                    run();
                }
            }
        })();

        return runningPromise;
    };

    return run;
}
